import { Route, Switch } from 'react-router-dom';
import { PageHeader } from 'client/js/util/layout_utils';
import AccessLogs from 'client/js/usercp/access_logs/index';
import ErrorLogs from 'client/js/usercp/error_logs/index';
import PhpErrorLogs from 'client/js/usercp/php_error_log/index';
import {AnimatedTabs, AnimatedNavItem} from 'client/js/util/nav_tabs';

const Index = () => (
  <>
    <Switch>
      <Route path="/access_logs" render={() => <PageHeader text="Zugriffslogs" />} />
      <Route path="/php_error_log" render={() => <PageHeader text="PHP-Fehler-Logs" />} />
      <Route path="/error_logs" render={() => <PageHeader text="Apache-Fehler-Logs" />} />
    </Switch>

    <AnimatedTabs>
      <AnimatedNavItem to="/access_logs">Zugriffslogs</AnimatedNavItem>
      <AnimatedNavItem to="/php_error_log">PHP-Fehler-Logs</AnimatedNavItem>
      <AnimatedNavItem to="/error_logs">Apache-Logs</AnimatedNavItem>
    </AnimatedTabs>

    <Switch>
      <Route path="/access_logs" render={() => <AccessLogs />} />
      <Route path="/php_error_log" render={() => <PhpErrorLogs />} />
      <Route path="/error_logs" render={() => <ErrorLogs />} />
    </Switch>
  </>
);

export default Index;
